function normalizeBaseUrl(input) {
  if (!input) return null;
  const raw = String(input).trim();
  if (!raw) return null;
  const withScheme = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(raw) ? raw : `https://${raw}`;
  try {
    return new URL(withScheme).origin;
  } catch (_e) {
    return null;
  }
}

function buildToggleUrl(domainUrl, status, domainKey = null) {
  const base = normalizeBaseUrl(domainUrl);
  if (!base) return null;
  const url = new URL("/notification/toggle", base);
  url.searchParams.set("status", String(status));
  if (domainKey) {
    url.searchParams.set("key", String(domainKey));
  }
  url.searchParams.set("_ts", String(Date.now()));
  return url.toString();
}

// Fire-and-forget callback without CORS requirement.
export function sendNotificationToggleCallback({ domainUrl, status, domainKey = null, timeoutMs = 8000 }) {
  return new Promise((resolve) => {
    const url = buildToggleUrl(domainUrl, status, domainKey);
    if (!url) {
      resolve({ ok: false, url: null, error: "invalid_domain_url" });
      return;
    }

    const img = new Image();
    let settled = false;

    const finish = (ok, error = null) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      img.onload = null;
      img.onerror = null;
      resolve({ ok, url, error });
    };

    const timer = setTimeout(() => finish(false, "timeout"), timeoutMs);
    img.onload = () => finish(true);
    img.onerror = () => finish(false, "network_error");
    img.src = url;
  });
}

